export function galleryScroll() {
	$(".gallery-photos .photos-wrap, .events-gallery .photos-wrap").mCustomScrollbar({
		axis:"x",
		theme:"dark-thin",
		autoExpandScrollbar:false,
		advanced:{autoExpandHorizontalScroll:true}
	});
};


// WEBPACK FOOTER //
// ./assets/js/modules/galleryScroll.js